import type { ComponentType } from "react";

import { FloorTab } from "features/technical-data/floor/components/FloorTab";
import { RoofTab } from "features/technical-data/roof/components/RoofTab";
import { RoomTab } from "features/technical-data/room/components/RoomTab";
import { WallTab } from "features/technical-data/wall/components/WallTab";
import { WindowTab } from "features/technical-data/window/components/WindowTab";

import { techDataSections } from "../../configs/TechnicalDataEnums";
// import { VentilationTab } from "./ventilation/components/VentilationTab";

type CustomTechDataTabEntry = {
  component: ComponentType<CustomTechDataTabProps>;
};

type CustomTechDataTabProps = {
  projectId: string;
};

const TECHNICAL_DATA_CUSTOM_TABS: Record<string, CustomTechDataTabEntry> = {
  [techDataSections.FLOOR]: { component: FloorTab },
  [techDataSections.ROOFTOP]: { component: RoofTab },
  [techDataSections.ROOM]: { component: RoomTab },
  // [techDataSections.VENTILATION]: { component: VentilationTab },
  [techDataSections.WALL]: { component: WallTab },
  [techDataSections.WINDOWS]: { component: WindowTab },
};

export const isCustomTechDataTab = (tabName: string) => tabName in TECHNICAL_DATA_CUSTOM_TABS;

export const getCustomTechDataTabNames = () => Object.keys(TECHNICAL_DATA_CUSTOM_TABS);

export const getCustomTechDataTabComponent = (tabName: string) => TECHNICAL_DATA_CUSTOM_TABS[tabName]?.component;

export const getLegacyTechDataTabNames = () =>
  Object.values(techDataSections).filter((tabName) => !isCustomTechDataTab(tabName));
